import { env } from '@/env'

export function AppVersion() {
  const version = VITE_APP_VERSION
  const shortSha = env.VITE_GITHUB_SHA?.slice(0, 7) ?? '-------'
  return (
    <div className="text-xs font-semibold text-fintalk">
      v{version}-{shortSha}
    </div>
  )
}
